export default "__VITE_ASSET__BsJ75Tru__"